import { render } from "./AlertDetails.vue?vue&type=template&id=5a84b66e&ts=true"
import script from "./AlertDetails.vue?vue&type=script&lang=ts"
export * from "./AlertDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__